import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

type Props = {
  value: string;
  toastMessage?: string;
  errorMessage?: string;
};

export const CopyToClipboardButton = ({ value, toastMessage, errorMessage }: Props) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => toast.success(toastMessage || 'Copied to clipboard'))
      .catch(() => toast.error(errorMessage || 'Failed to copy'));
  };

  return (
    <Button type="button" variant="outline" onClick={handleCopy}>
      <Copy size={16} />
    </Button>
  );
};
